import { connect } from 'react-redux'
import { defineMessages } from 'react-intl'
import { selectDreamHomeBudget } from 'src/store/selectors/home/equity'
import DreamHomeDetail from './DreamHomeDetail'

export default {
  GemContainer: connect(state => ({
    qaTag: 'dreamHomeGem',
    amount: selectDreamHomeBudget(state)
  })),
  Detail: DreamHomeDetail,
  ...defineMessages({
    question: {
      id: 'Homeowner.purchasePower.dreamHomeQuestion',
      defaultMessage: 'How do I get started?'
    },
    topic: {
      id: 'Homeowner.purchasePower.dreamHomeTopic',
      defaultMessage: 'buying their dream home'
    }
  })
}
